import React from 'react';

import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';

import Icon from 'app/components/Icon';
import { Col, Row } from 'react-bootstrap';
import { Divider } from '@material-ui/core';
import { commonFormValidation } from 'app/modules/MyAccount/pages/Billing/utils/commonFormValidation';

export const freelanceFormFields = [
  {
    component: (
      <p className="big bold title">
        <FormattedMessage id="controlpanel.form.title.self_employed_data" />
      </p>
    )
  },
  {
    name: 'company',
    labelKey: 'controlpanel.form.label.social_reason',
    disabled: true
  },
  {
    component: (
      <Row>
        <Col md={10} className="mg-bt-25">
          <Divider />
        </Col>
      </Row>
    )
  },
  {
    component: (
      <p className="big bold title">
        <FormattedMessage id="controlpanel.form.title.tax_information" />
      </p>
    )
  },
  {
    name: 'country',
    labelKey: 'controlpanel.form.label.country',
    disabled: true
  },
  {
    name: 'vat',
    labelKey: 'controlpanel.form.label.nif',
    disabled: true
  },
  {
    name: 'eori',
    labelKey: 'controlpanel.form.label.eori'
  },
  {
    name: 'voec',
    labelKey: 'controlpanel.form.label.voec'
  },
  {
    component: (
      <Row>
        <Col md={10} className="mg-bt-25">
          <Divider />
        </Col>
      </Row>
    )
  },
  {
    component: (
      <p className="big bold title">
        <FormattedMessage id="controlpanel.form.title.address" />
      </p>
    )
  },
  {
    name: 'address',
    labelKey: 'controlpanel.form.label.address',
    disabled: true
  },
  {
    name: 'city',
    labelKey: 'controlpanel.form.label.city',
    disabled: true
  },
  {
    name: 'postCode',
    labelKey: 'controlpanel.form.label.postal_code',
    disabled: true
  },
  {
    name: 'state',
    labelKey: 'controlpanel.form.label.province',
    disabled: true
  },
  {
    component: (
      <Row>
        <Col md={10} className="mg-bt-25">
          <Divider />
        </Col>
      </Row>
    )
  },
  {
    component: (
      <p className="big bold title">
        <FormattedMessage id="controlpanel.form.title.contact_information" />
      </p>
    )
  },
  {
    name: 'phonePrefix',
    labelKey: 'controlpanel.form.label.phonePrefix',
    disabled: false
  },
  {
    name: 'phone',
    labelKey: 'controlpanel.form.label.telephone',
    textPrepend: <Icon prefix="fas" icon="phone-flip" />,
    disabled: false
  },
  {
    name: 'url',
    labelKey: 'controlpanel.form.label.web',
    disabled: false
  }
];
export const freelanceFormValidation = Yup.object({ ...commonFormValidation });
